const QUERY_ERROR = 'query-error';
const APP_EVENT = 'trackCustomEvent';

// trigger custom event
// apphub will capture and push this to sensor
function apptracker(name, data) {
  const event: any = new CustomEvent(APP_EVENT, {
    detail: {
      name,
      data,
    },
  });
  document.dispatchEvent(event);
}

export const trackQueryError = (params) => apptracker(QUERY_ERROR, params);

export default apptracker;
